import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CheckoutLayout } from 'common/components/layout';
import { getClubMembership } from 'redux/clubMemberships/actions';

import ControlledSubscriptionShipment from './shipment/ControlledSubscriptionShipment';
import SubscriptionShipment from './shipment/SubscriptionShipment';
import TraditionalShipment from './shipment/TraditionalShipment';

const ClubMembershipShipment = (props) => {
  const { match } = props;
  const { id } = match.params;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getClubMembership(id));
  }, [dispatch, id]);

  const settings = useSelector((state) => state.setting);
  const clubMembershipReducer = useSelector((state) => state.clubMembership);

  if (!settings.data || !clubMembershipReducer.data) {
    return (
      <CheckoutLayout title="Club Shipment" loading>
        &nbsp;
      </CheckoutLayout>
    );
  }

  const clubMembership = clubMembershipReducer.data[id];
  if (clubMembership.clubType === 'Traditional') {
    return <TraditionalShipment clubMembership={clubMembership} />;
  }
  if (clubMembership.clubType === 'Controlled Subscription') {
    return <ControlledSubscriptionShipment clubMembership={clubMembership} />;
  }
  if (clubMembership.clubType === 'Subscription') {
    return <SubscriptionShipment clubMembership={clubMembership} />;
  }
  return <h1>Subscription Shipment</h1>;
};

export default ClubMembershipShipment;
